<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$info"
    :title="$t('training_task_informations')"
    :loading="loading"
    :max-width="800"
    color="info"
    activator-icon
    @escape="closeDialog"
    @open="showDialogTrainingTaskInfo"
  >
    <template v-slot:info>
      <v-card-text
        id="training-task-info"
      >
        <pre style="text-wrap: balance"> {{ description }} </pre>
      </v-card-text>
    </template>
  </cumulus-info-dialog>
</template>

<script>
  import CumulusInfoDialog from '@/components/InfoDialog.vue'

  export default {
    name: 'TrainingTaskInformations',
    components: { CumulusInfoDialog },
    props: {
      description: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        dialogInfo: false,
        loading: false,
      }
    },
    computed: {
      // loading: get('app/loading'),
    },
    watch: {
      dialogInfo (val) {
        // this.showDialogFlightInfo()
        val || this.closeDialog()
      },
      trainingTask (val) {
      },
    },
    mounted () {
    },
    methods: {
      closeDialog () {
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)

#training-task-info
  .row
    padding-top: 0px
    padding-bottom: 0px

</style>
